export const GET_ALL_SP = 'associateRatesToReference/GET_ALL_SP';
